import styled from 'styled-components'
import { Checkbox } from 'antd'
import { greys } from 'assets/themes/theme-default'

const AntCheckboxStyled = styled(Checkbox)`
  &&& {
    :hover {
      .ant-checkbox-checked {
        .ant-checkbox-inner {
          border-color: ${props => props.theme.colors.color1.bg};
        }
      }
    }
    .ant-checkbox-checked {
      .ant-checkbox-inner {
        border-color: ${props => props.theme.colors.color1.bg};
        background-color: ${props => props.theme.colors.color1.bg};
        :after {
          border-color: ${greys.light4};
        }
      }
    }
  }
`

export default AntCheckboxStyled
